"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FIN_VENDOR_INVOICE_RESPONSE_EXAMPLE = void 0;
exports.FIN_VENDOR_INVOICE_RESPONSE_EXAMPLE = {
    id: '55555555-5555-4555-8555-555555555555',
    invoiceNumber: 'EXP-INV-2026-000001',
    invoiceType: 'EXPENSE',
    branchId: '22222222-2222-4222-8222-222222222222',
    hospitalId: null,
    vendorId: '66666666-6666-4666-8666-666666666666',
    vendorInvoiceRef: 'VEND/2026/0042',
    expenseAccountId: '77777777-7777-4777-8777-777777777777',
    invoiceDate: '2026-07-20',
    dueDate: '2026-08-19',
    grossAmount: 100000,
    discountAmount: 0,
    taxAmount: 18000,
    tdsAmount: 10000,
    netAmount: 118000,
    amountPaid: 0,
    amountOutstanding: 108000,
    overpaidAmount: 0,
    status: 'OPEN',
    cancelReason: null,
    writeOffReason: null,
    sourceEventLogId: '88888888-8888-4888-8888-888888888888',
    createdAt: '2026-07-20T09:55:00.000Z',
};
//# sourceMappingURL=financial-payable.response.js.map